import { Link } from 'react-router-dom';
import { getCurrentUser } from '@/lib/auth';
import { Card } from '@/components/ui/Card';
import { ThemeToggle } from '@/components/ui/ThemeToggle';

export default function NotFound() {
  const currentUser = getCurrentUser();
  const homeLink = currentUser ? '/users' : '/login';
  const homeLinkLabel = currentUser ? 'Go to Users' : 'Go to Log In';

  return (
    <div className="min-h-screen w-full bg-surface flex items-center justify-center px-4 relative">
      <div className="absolute top-4 right-4">
        <ThemeToggle />
      </div>
      <Card glass className="w-full max-w-md p-8">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-6">
            <div className="flex flex-col items-center gap-1 mb-2">
              <h1 className="text-2xl font-bold text-text-primary tracking-tight">Rainmaker</h1>
              <span className="text-xs font-semibold text-primary-600 tracking-widest uppercase">
                Admin
              </span>
            </div>
          </div>
          <h2 className="text-2xl font-semibold text-text-primary">Page Not Found</h2>
        </div>

        <div className="space-y-6 text-center">
          <p className="text-text-secondary text-sm">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <Link
            to={homeLink}
            className="inline-block text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 font-medium hover:underline text-sm"
          >
            {homeLinkLabel}
          </Link>
        </div>
      </Card>
    </div>
  );
}
